module.exports = __webpack_public_path__ + "static/media/frizo-meet-new-clients.f5d4dc70.png";